import { HttpErrorResponse, HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { ROUTES_CONSTANT } from "app/core/constants";
import { KeycloakService } from "keycloak-angular";
import { catchError, throwError } from "rxjs";

/**
 * Debe registrarse DESPUÉS de authInterceptor en withInterceptors([...]):
 * así, si el 401 ocurre pese a haber renovado el token, sabemos que la sesión
 * ya no es válida y no que faltó adjuntar el header.
 */
export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const keycloakService = inject(KeycloakService);
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {

      console.error("[httpErrorInterceptor] request failed", {
        url: error.url,
        status: error.status,
        statusText: error.statusText,
        body: error.error,
      });

      if (error.status === 401) {
        keycloakService.login({ redirectUri: window.location.href });
       } else if (error.status === 403) {
         router.navigate([ROUTES_CONSTANT.forbidden.absolutePath]);
       }

      // Se propaga siempre para que el componente que hizo el request pueda reaccionar.
      return throwError(() => error);
    }),
  );
};
